import RootRoutes from './routes';
import React from 'react';
import './css/base.css';
import './css/layout.css';
import './css/page.css';
import './css/response.css';
import ScrollButton from 'components/ScrollButton';
import Header from 'components/Header';
function App() {
  return (
    <>
    <Header />
    <div className="wrap">
      {/* <React.StrictMode> */}
        <RootRoutes />
        {/* <ScrollButton/> */}
      {/* </React.StrictMode> */}
    </div>
    </>
  )
}

export default App;
